var AUTO_SLIDESHOW_TYPES = {
  INTERVAL: 'interval',
  CONTINUOUS: 'continuous'
};
export default AUTO_SLIDESHOW_TYPES;